import React from 'react';
import PropTypes from 'prop-types';

const ResolutionSdPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M28 20.99A3.006 3.006 0 0 1 24.992 24H7.008A3.002 3.002 0 0 1 4 20.99v-9.98A3.006 3.006 0 0 1 7.008 8h17.984A3.002 3.002 0 0 1 28 11.01v9.98zm-8.634-.986c2.508 0 4.419-1.518 4.419-4.002S21.874 12 19.354 12h-3.36v8.004h3.372zm0-2H18v-4h1.366c1.464 0 2.208.756 2.208 1.992 0 1.188-.804 2.008-2.208 2.008zM11.723 20.1c2.13 0 3.308-1.06 3.308-2.654 0-2.952-4.486-2.214-4.486-3.19 0-.345.261-.547.856-.547a3.68 3.68 0 0 1 2.321.833l1.119-1.535c-.845-.726-1.952-1.107-3.225-1.107-2.035 0-3.154 1.19-3.154 2.523 0 3.059 4.487 2.19 4.487 3.237 0 .393-.429.631-1.12.631a3.594 3.594 0 0 1-2.546-1.047L8.2 18.838c.797.75 1.916 1.262 3.523 1.262z"
    />
  );
};

ResolutionSdPath.propTypes = {
  fill: PropTypes.string,
};

export default ResolutionSdPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/technology/resolution-sd.jsx